/* Floating cart button (sections/sticky-cart.liquid). Refreshes from the section's own render whenever the cart changes
   (Dawn's cartUpdate event), pops when the count goes up, and opens the cart drawer on tap (cart page link if there is no drawer). */
if (!customElements.get('sticky-cart')) {
  customElements.define(
    'sticky-cart',
    class StickyCart extends HTMLElement {
      connectedCallback() {
        this.count = Number(this.dataset.count) || 0;
        this.addEventListener('click', (event) => {
          if (!event.target.closest('.sticky-cart__btn')) return;
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open(event.target.closest('.sticky-cart__btn'));
          else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
        window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      async refresh() {
        try {
          const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const html = await (await fetch(root + '?section_id=sticky-cart')).text();
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('sticky-cart');
          if (!next) return;
          const count = Number(next.dataset.count) || 0;
          this.innerHTML = next.innerHTML;
          this.dataset.count = count;
          this.classList.toggle('is-hidden', count === 0 || this.dataset.page === 'cart');
          if (count > this.count) {
            this.classList.remove('is-pop');
            void this.offsetWidth;
            this.classList.add('is-pop');
          }
          this.count = count;
        } catch (error) {}
      }
    }
  );
}
